export default {
  headers: {
    title: 'Listado de facturas de terceros por gastos suplidos',
    created: 'F. creación',
    id: 'Serie - Número',
    provider: 'Proveedor',
    status: 'Estado',
    type: 'Tipo',
    serie: 'Serie',
    number: 'Número',
    amount: 'Importe'
  },
  search: {
    title: 'Buscador'
  },
  filter: {
    byCreated: 'Fecha de creación',
    byEmited: 'Fecha de emisión',
    from: 'Desde',
    to: 'Hasta',
    byId: 'Serie y número',
    bySerie: 'Serie',
    byNumber: 'Número',
    byStatus: 'Estado',
    byProviderDocument: 'NIF/CIF/NIE Proveedor',
    byAmount: 'Importe (€)'
  },
  delete: {
    confirmDeleteTitle: 'Eliminar factura de terceros seleccionada',
    question: '¿Está seguro que desea eliminar la factura de terceros seleccionada?'
  },
  send: {
    invoice: 'Enviar factura',
    invoices: 'Enviar facturas'
  }
}
